import { BehaviorSubject } from 'rxjs';
import { GameServices } from '../../services/game-services';
import { BlackjackTranslationsType } from '../../model/blackjack-types';

export class RoundedNumberViewModel {
  public get prefix(): string {
    return this.gameServices.gameTranslationService.getTranslation(this.prefixKey);
  }
  public get defaultFontFamily() {
    return this.gameServices.gameThemeService.defaultFontFamily;
  }
  public get currentNumber$() {
    return this.currentNumber.asObservable();
  }

  private readonly currentNumber: BehaviorSubject<number>;

  constructor(
    private gameServices: GameServices,
    private prefixKey: BlackjackTranslationsType,
    value: number,
    readonly backgroundColor: number,
    readonly backgroundAlpha: number,
  ) {
    this.currentNumber = new BehaviorSubject<number>(value);
  }

  public setNumber(value: number): void {
    this.currentNumber.next(value);
  }
}
